var map = {
	"./aave-transactions.json": 60989,
	"./balancer-transactions.json": 87211,
	"./bitcoin-transactions.json": 52657,
	"./compound-transactions.json": 83874,
	"./curve-transactions.json": 47858,
	"./dodo-transactions.json": 6429,
	"./frax-transactions.json": 7909,
	"./instadapp-transactions.json": 14360,
	"./lido-transactions.json": 1581,
	"./yearn-transactions.json": 69190
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82805;